import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import AssetManager from '../../common/components/AssetManager/AssetManager'
import Modal from './index'

import HashList from '../../utils/hashlist'
import Editor from '../Editor/Editor'

class DataProviderLayer extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            ready_show: false,
            saving_process: false,
            dataSet: null,
            selectedDataId: null,
            asset_manager_modal: {
                is_open: false,
                active_item_index: null,
            },
        }
        this.isMemoryProject = this.props.project.projectType.customId.toLocaleUpperCase() === 'MEMORY'
        this.base_state = this.state
        this.editor = Editor
    }

    componentDidMount() {
        this.setComponentData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.is_open && this.props.is_open) {
            this.setComponentData()
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    handleClick__save = evt => {
        evt.preventDefault()
        this.setComponentData()
        const { dataSet } = this.state
        if (dataSet && typeof dataSet[Symbol.iterator] === 'function') {
            const saveData = new HashList([...dataSet])
            this.props.events.on_save(saveData)
            this.props.events.on_close()
        }
    }

    handleClick__open_asset_manager_modal = selectedDataId => evt => {
        evt.preventDefault()

        this.setState(prevState => ({
            selectedDataId: selectedDataId,
            asset_manager_modal: {
                ...prevState.asset_manager_modal,
                is_open: true,
            },
        }))
    }

    handleClick__close_asset_manager_modal = () => {
        this.setState(prevState => ({
            asset_manager_modal: {
                ...prevState.asset_manager_modal,
                is_open: false,
            },
        }))
    }

    handleClick__place_image = ({ src, id }) => {
        const { selectedDataId, dataSet } = this.state
        const dataItemIndex = dataSet.findIndex(x => x.id === selectedDataId)
        const updatedDataset = [...dataSet]

        if (this.isMemoryProject) {
            if (updatedDataset[dataItemIndex]) {
                updatedDataset[dataItemIndex].src = src
                updatedDataset[dataItemIndex].gameKey = id
                this.setState({
                    dataSet: updatedDataset,
                })
            }
        }
    }

    setComponentData = () => {
        let data
        this._isMounted = true

        this.editor.serializeProject().then(response => {
            const { screens } = response.router || { screens: [] }
            if (this.isMemoryProject && screens) {
                data = this.getMemoryPlaygroundData(screens[this.editor.getActiveScreen()])
            } else {
                console.warn('[DataProviderLayer]: Unknown project')
            }
            this.setState({
                ready_show: true,
                dataSet: data,
            })
        })
    }

    getMemoryPlaygroundData = activeScreen => {
        let data
        if (!activeScreen) {
            return console.warn('[DataProviderLayer]: No active screen was found!')
        }
        const [dataComponent] = Object.values(activeScreen.components)
            .filter(x => !Array.isArray(x))
            .filter(x => x.displayName === 'MemoryPlayground')
        if (!dataComponent) {
            return console.warn('[DataProviderLayer]: No component for data provider was found!')
        }
        const dataSetFromResponse = Object.values(dataComponent.dataSet).filter(x => x.id >= 0)
        if (!dataSetFromResponse) {
            return console.warn('[DataProviderLayer]: No data in response!')
        }
        const [cardRowsCount, cardsInRowCount] = dataComponent.cardRowOption.split('x').map(x => Number(x))
        const cardsCount = (cardRowsCount * cardsInRowCount) / 2

        if (dataSetFromResponse.length === 0) {
            return this.memoryProjectGetData(dataComponent.cardRowOption)
        }

        if (cardsCount === dataSetFromResponse.length) {
            data = dataSetFromResponse
        } else if (cardsCount < dataSetFromResponse.length) {
            data = dataSetFromResponse.splice(0, cardsCount)
        } else {
            data = dataSetFromResponse
        }

        return data
    }

    getItemsView = () => {
        const st = {
            color: '#000',
        }

        if (this.isMemoryProject) {
            const { dataSet } = this.state
            const memoryCardPairStyle = {
                color: '#000',
                display: 'flex',
                margin: '.5rem',
                width: '125px',
                height: '50px',
                position: 'relative',
            }
            const memoryCardStyle = {
                width: '60px',
                height: '60px',
                margin: '.2rem',
                borderRadius: '4px',
                border: '1px solid #D8D8D8',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }
            const cameraCtaStyle = {
                position: 'absolute',
                cursor: 'pointer',
                top: 35,
                left: 30,
            }
            const cameraCtaSvg = cardId => (
                <svg
                    style={cameraCtaStyle}
                    onClick={this.handleClick__open_asset_manager_modal(cardId)}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="24" height="24" rx="3" fill="black" fillOpacity="0.2" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17 7H14.387C14.3018 6.43397 13.8134 6 13.2236 6H10.7766C10.1868 6 9.69839 6.43397 9.61324 7H7C6.44772 7 6 7.44772 6 8V16C6 16.5523 6.44772 17 7 17H17C17.5523 17 18 16.5523 18 16V8C18 7.44772 17.5523 7 17 7ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM11.9998 14C13.1044 14 13.9998 13.1046 13.9998 12C13.9998 10.8954 13.1044 10 11.9998 10C10.8953 10 9.99983 10.8954 9.99983 12C9.99983 13.1046 10.8953 14 11.9998 14Z"
                        fill="white"
                    />
                </svg>
            )

            if (dataSet && dataSet.map) {
                return dataSet.map((item, i) => (
                    <div style={memoryCardPairStyle} key={i}>
                        <div style={{ ...memoryCardStyle, backgroundImage: `url(${item.src})` }}>
                            {cameraCtaSvg(item.id)}
                        </div>
                        <div style={{ ...memoryCardStyle, backgroundImage: `url(${item.src})`, opacity: '.5' }}> </div>
                    </div>
                ))
            }
        }

        return <div style={st}> Your project markup </div>
    }

    memoryProjectGetData(cardRowOption) {
        let cardsData = []
        const [cardRowsCount, cardsInRowCount] = cardRowOption.split('x').map(x => Number(x))
        const cardsCount = (cardRowsCount * cardsInRowCount) / 2
        const isValidProp = x => typeof x === 'number' && x > 0

        if (!isValidProp(cardRowsCount) || !isValidProp(cardsInRowCount)) {
            return console.warn('[MemoryData]: Bad props from cardRowsCount!')
        }

        for (let i = 0; i < cardsCount; i++) {
            cardsData.push({ id: i, gameKey: null, src: '' })
        }
        return cardsData
    }

    onExited = async () => {}

    render() {
        const dataProviderStyle = {
            display: 'flex',
            height: '540px',
            flexFlow: 'row wrap',
            margin: '0 auto',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'flex-start',
            padding: '75px',
        }

        const { asset_manager_modal, ready_show } = this.state
        const { is_open, overlay_close, events, project, t } = this.props

        return ready_show ? (
            <>
                <Modal
                    settings={{ overlay_close: overlay_close }}
                    classes={{
                        overlay: '',
                        modal: 'share-style share-options-style',
                        closeButton: '',
                        closeIcon: '',
                    }}
                    data={{ open: is_open, max_width: 960 }}
                    events={{ onCloseModal: events.on_close, onExited: this.onExited }}
                >
                    <div className="head head-v1">{t('_components._modal._memory_options.title')}</div>
                    <div className="wrap">
                        <div style={dataProviderStyle} className={'rmx-data-provider with-menu'}>
                            {/*
                                Customizable view of project items
                            */}
                            {this.getItemsView()}
                        </div>
                        <div className="bottom-bar">
                            <div className="left">
                                {/*Note text*/}
                                <p></p>
                            </div>
                            <div className="right">
                                <button
                                    className="button"
                                    data-variant="secondary"
                                    data-size="lg"
                                    onClick={events.on_close}
                                >
                                    {t('Cancel')}
                                </button>
                                <button
                                    className="button"
                                    data-variant="primary"
                                    data-size="lg"
                                    disabled={false}
                                    onClick={this.handleClick__save}
                                >
                                    {t('_common.save')}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <AssetManager
                    isOpen={asset_manager_modal.is_open}
                    projectId={project.projectId}
                    onPlaceImage={this.handleClick__place_image}
                    onClose={this.handleClick__close_asset_manager_modal}
                />
            </>
        ) : null
    }
}

export default compose(connect(null, null), withTranslation('translations'))(DataProviderLayer)
